import { actionTypes } from "./constants";

const initialState = {
  productList: {
    list: [],
    total: 0,
  },
  suiteList: {
    list: [],
    total: 0
  },
  solutionList: {
    list: [],
    total: 0
  },
  majorUpgradeList: [],
  productClassify: {
    list: [],
    total: 0
  },
  solutions: [],
  cases: [],
  categoryList: [],
  productDetail: {},
  productSuite: {},
  solutionDetail: {},

  pageInfo: {
    page: 1,
    size: 10,
  },

  productChange: {
    ANNOUNCEMENT: {
      title: [],
      total: 0,
    },
    NEW: {
      list: [],
      total: 0,
    },
    OLD: {
      list: [],
      total: 0,
    },
    PRICE_CHANGE: {
      list: [],
      total: 0,
    },
    PROMOTION: {
      list: [],
      total: 0,
    },
    MAJOR_UPGRADE: {
      list: [],
      total: 0,
    },
  },

  promotionList: {
    list: [],
    total: 0,
  },

  levelOne: {
    rows: [],
    count: 0,
  },
  levelTwo: {
    rows: [],
    count: 0,
  },
  solutionHistory: [],
  productCaseAreaList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PRODUCT_LIST:
      return {
        ...state, productList: action.data,
      };
    case actionTypes.SET_SUITE_LIST:
      return {
        ...state, suiteList: action.data,
      };
    case actionTypes.SET_SOLUTION_LIST:
      return {
        ...state, solutionList: action.data,
      };
    case actionTypes.SET_SOLUTION:
      return {
        ...state, solutions: action.data,
      };
    case actionTypes.SET_CASE:
      return {
        ...state, cases: action.data,
      };
    case actionTypes.SET_CATEGORY_LIST:
      return {
        ...state, categoryList: action.data,
      };
    case actionTypes.SET_PRODUCT_DETAIL:
      return {
        ...state, productDetail: action.data,
      };
    case actionTypes.SET_PRODUCT_SUITE:
      return {
        ...state, productSuite: action.data,
      };
    case actionTypes.SET_SOLUTION_DETAIL:
      return {
        ...state, solutionDetail: action.data,
      };
    case actionTypes.SET_PRODUCT_CLASSIFY_LIST:
      return {
        ...state, productClassify: action.data,
      };
    case actionTypes.SET_MAJOR_UPGRADE_LIST:
      return {
        ...state, majorUpgradeList: action.data,
      };
    case actionTypes.SET_SAVE_PAGE_INFO:
      return {
        ...state, pageInfo: action.data,
      };
    case actionTypes.SET_PROJECT_CHANGE_LIST:
      return {
        ...state, productChange: action.data,
      };
    case actionTypes.SET_PROMOTION_LIST:
      return {
        ...state, promotionList: action.data,
      };
    case actionTypes.SET_SOLUTION_LEVEL_ONE:
      return {
        ...state, levelOne: action.data,
      };
    case actionTypes.SET_SOLUTION_LEVEL_TWO:
      return {
        ...state, levelTwo: action.data,
      };
    case actionTypes.SET_SOLUTION_HISTORY_SET:
      return {
        ...state, solutionHistory: action.data,
      };
    case actionTypes.SET_PRODUCT_CASE_AREA_LIST:
      return {
        ...state, productCaseAreaList: action.data,
      };
    default:
      return state;
  }
};

export default reducer;